
import { defineComponent } from "vue";
import {
  setLeaderUsername,
  UnilevelMember,
} from "@/store/Unilevel/UnilevelInterfaces";
import { CarrerSummaryTable } from "./";
import { images } from "@/mixins/images";
import { mapGetters } from "vuex";
import PackageIcon from "@/components/common/PackageIcon.vue";
import { productVisual } from "@/components/common/productVisuals";

export default defineComponent({
  name: "carrer-summary-card",
  components: { CarrerSummaryTable, PackageIcon },
  props: {
    leader: { required: false, type: Object as () => UnilevelMember },
    searching: { required: true, type: Boolean, default: false },
  },
  emits: ["searchUser", "reloadUser"],
  data() {
    return {
      leaderPicture: "",
      searchUsernameString: "",
    };
  },
  computed: {
    ...mapGetters("auth", ["getUserProfile", "getUsernamePK"]),
    loggedUserEnroller(): string {
      return this.getUserProfile.enroller;
    },
    userNotFound(): boolean {
      return this.leader?.username == "@@USER_NOT_FOUND@@";
    },
    isVIP(): boolean {
      const isVIP = this.leader?.subscriptions.has("mmi-colombia") ?? false;
      return isVIP;
    },
    /**
     * El paquete del líder, TAL CUAL viene del backend.
     *
     * No se normaliza aquí a propósito: `PackageIcon` acepta cualquiera de los
     * vocabularios —nivel vivo, etiqueta retirada o doc-id— y hace él la
     * traducción, que es justo el contrato que documenta su prop `product`.
     * Normalizar en el llamante es cómo se llega a tener la misma tabla de
     * equivalencias copiada en diez pantallas.
     *
     * La cadena vacía cuando no hay paquete NO es un descuido: es lo que hace
     * que el `v-if` de la plantilla no pinte nada. Sin ella, `PackageIcon`
     * dibujaría su caja gris de «desconocido» colgando de la foto de todo el
     * que aún no tenga nada contratado, que es ruido y no información.
     */
    leaderPackageId(): string {
      return this.leader?.subscriptionPackage?.package?.packageId ?? "";
    },
    // El nombre comercial para el `title`. Sale del catálogo visual y no de un
    // literal, para que un cambio de nombre de producto se haga en un sitio.
    leaderPackageLabel(): string {
      return productVisual(this.leaderPackageId).label;
    },
  },
  methods: {
    changeTeamLeader(newLeaderUsername?: string) {
      this.$store.dispatch("unilevel/" + setLeaderUsername, newLeaderUsername);
    },
    searchUser() {
      this.$emit("searchUser", this.searchUsernameString.toLowerCase());
    },
    refresh() {
      this.$emit("reloadUser", this.leader?.username);
    },
  },
  created() {
    if (this.leader) {
      this.getProfilePicture(this.leader.pictureUrl).then((url) => {
        this.leaderPicture = url;
      });
    }
  },
  setup() {
    const getProfilePicture = images.methods.getProfilePicture;
    return {
      getProfilePicture,
    };
  },
  watch: {
    "leader.pictureUrl": function (newValue) {
      if (newValue != undefined) {
        this.getProfilePicture(newValue).then((url) => {
          this.leaderPicture = url;
        });
      }
    },
  },
});
